<template>
  <div>
    <navigation-main bg="true" />
    <div class="main-content">
      <main role="main" class="flex-grow-1 overflow-auto">
        <div id="content">
          <section class="page-section">
            <div class="container">
              <div class="row ">
                <div class="col-12">
                  <h2 class="text-black mb-0">
                    Citation
                  </h2>
                  <hr class="divider dark m-0 mb-1" style="max-width: 100% !important;" />
                </div>
                <div class="col-12">
                  <p class="mt-2">
                    If you use <strong>MUSES</strong> in your work, please cite this publication:
                  </p>
                  <CiteComponent></CiteComponent >
                </div>
              </div>

            </div>
          </section>
        </div>
      </main>
    </div>
  </div>
</template>
<script>
import NavigationMain from "@/views/navigation/navigation-main";
import CiteComponent from "./CiteComponent.vue";

export default {
  name: "CitationPage.vue",
  components: {
    NavigationMain,
    CiteComponent
  }
};
</script>
